import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Grid, Typography, AlertLabs, units } from '@hbf/dsl';

const useStyles = makeStyles()(() => ({
  alertLabs: {
    padding: units.yx(0, 0.5),
    marginTop: units.rem(0.5),
    marginBottom: units.rem(1),
  },
}));

const CharityInfoBannerInternal: React.FC = () => {
  const { T } = useIntl();
  const { classes } = useStyles();

  return (
    <Grid item xs={12} data-test-locator="Registration Info Section">
      <AlertLabs severity="success" icon={false} className={classes.alertLabs}>
        <Typography.Caption>
          {T('ukr_response.no_service_fee')}
        </Typography.Caption>
      </AlertLabs>
    </Grid>
  );
};

const CharityInfoBanner = React.memo(CharityInfoBannerInternal);
export { CharityInfoBanner };
